export const environment = {
    production: true,
    apiUrl: '/service/api',
    showDebugMsg: false,
    minPasswordLength: 9,
    maxPasswordLength: 16,
    showLanguageSwitch: true,
    reCaptchaSiteKey: '6LcucQsTAAAAABRaoAvzTpu5kmDug8KjM8KpHLpk',
    minDate: new Date(1900, 0, 1),
    maxDate: new Date(2154, 11, 31),
    defaultLanguage: 'lv',
    startRoute: '',
    adfsApiRoute: '/adfs'
};
